import axios from "axios";

export default function ProjecttypeListService(query) {
  if (query && query.toString().includes(',"multiSortMeta":[]')) {
    query = query.replace(',"multiSortMeta":[]', '')
  }

  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/api/v2/project-type" + (query ? "?" + query : ""),
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  }).then(response => {
    const data = response.data?.data || response.data || {};

    return {
      ...response,
      data: {
        ...data,
        items: data.items || [],
        total_item_count: data.total_item_count ?? data.items?.length ?? 0,
      },
    };
  });
}
